import React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

//TODO: SPlit this file into individual icon files so they can be reused more easily
// e.g. CompositionIcon.tsx, MaterialPropertiesIcon.tsx, MethodIcon.tsx, GalleryIcon.tsx

export const CompositionIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 35.742 38.384">
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectangle_1412"
          data-name="Rectangle 1412"
          width="35.742"
          height="38.384"
          fill="#609690"
        />
      </clipPath>
    </defs>
    <g
      id="Composition_icon_"
      data-name="Composition icon "
      transform="translate(0 0)"
    >
      <g
        id="Group_1909"
        data-name="Group 1909"
        transform="translate(0 0)"
        clip-path="url(#clip-path)"
      >
        <path
          id="Path_2734"
          data-name="Path 2734"
          d="M1.525,17.708a.855.855,0,0,1-.856-.856V5.72a.856.856,0,1,1,1.712,0V16.852a.855.855,0,0,1-.856.856"
          transform="translate(1.24 9.012)"
          fill="#609690"
        />
        <path
          id="Path_2735"
          data-name="Path 2735"
          d="M2.3,8.811a.856.856,0,0,1-.428-1.6l9.1-5.255a.855.855,0,1,1,.856,1.481l-9.1,5.255a.824.824,0,0,1-.425.117"
          transform="translate(2.669 3.411)"
          fill="#609690"
        />
        <path
          id="Path_2736"
          data-name="Path 2736"
          d="M11.78,6.329a.824.824,0,0,1-.425-.117l-4.8-2.773A.856.856,0,0,1,7.4,1.955l4.8,2.776a.856.856,0,0,1-.428,1.6"
          transform="translate(11.343 3.411)"
          fill="#609690"
        />
        <path
          id="Path_2737"
          data-name="Path 2737"
          d="M10.94,22.2a.855.855,0,0,1-.856-.856V8.838A16.943,16.943,0,0,1,11.5,2.9a.847.847,0,0,1,1.158-.354A.857.857,0,0,1,13.014,3.7a15.494,15.494,0,0,0-1.221,5.187l0,12.462a.855.855,0,0,1-.856.856"
          transform="translate(18.686 4.517)"
          fill="#609690"
        />
        <path
          id="Path_2738"
          data-name="Path 2738"
          d="M6.979,16.964a.856.856,0,0,1-.428-1.6l9.064-5.232a.855.855,0,1,1,.856,1.481L7.4,16.85a.849.849,0,0,1-.425.114"
          transform="translate(11.343 18.564)"
          fill="#609690"
        />
        <path
          id="Path_2739"
          data-name="Path 2739"
          d="M11.2,16.867a.849.849,0,0,1-.425-.114l-8.9-5.135a.856.856,0,0,1,.856-1.484l8.9,5.135a.856.856,0,0,1-.428,1.6"
          transform="translate(2.694 18.564)"
          fill="#609690"
        />
        <path
          id="Path_2740"
          data-name="Path 2740"
          d="M7.533,6.522A2.87,2.87,0,0,1,5.094,2.154,2.869,2.869,0,1,1,8.209,6.442a2.88,2.88,0,0,1-.676.08m.011-4.28a1.482,1.482,0,0,0-.334.04,1.4,1.4,0,1,0,.334-.04"
          transform="translate(8.655 1.452)"
          fill="#609690"
        />
        <path
          id="Path_2741"
          data-name="Path 2741"
          d="M7.533,17.181a2.878,2.878,0,1,1,.676-.08,2.881,2.881,0,0,1-.676.08m.011-4.28a1.482,1.482,0,0,0-.334.04,1.4,1.4,0,1,0,.334-.04"
          transform="translate(8.655 21.203)"
          fill="#609690"
        />
        <path
          id="Path_2742"
          data-name="Path 2742"
          d="M2.859,14.579a2.878,2.878,0,1,1,.679-.08,2.887,2.887,0,0,1-.679.08m.014-4.28a1.482,1.482,0,0,0-.334.04,1.4,1.4,0,1,0,.334-.04"
          transform="translate(-0.001 16.381)"
          fill="#609690"
        />
        <path
          id="Path_2743"
          data-name="Path 2743"
          d="M12.208,14.579a2.878,2.878,0,1,1,.676-.08,2.881,2.881,0,0,1-.676.08m.011-4.28a1.482,1.482,0,0,0-.334.04,1.4,1.4,0,1,0,.334-.04"
          transform="translate(17.318 16.381)"
          fill="#609690"
        />
        <path
          id="Path_2744"
          data-name="Path 2744"
          d="M2.859,9.108a2.878,2.878,0,1,1,.679-.08,2.887,2.887,0,0,1-.679.08m.014-4.28a1.482,1.482,0,0,0-.334.04,1.4,1.4,0,1,0,.334-.04"
          transform="translate(-0.001 6.243)"
          fill="#609690"
        />
        <path
          id="Path_2745"
          data-name="Path 2745"
          d="M14.217,15.635a5.874,5.874,0,0,1-4.359-2c-3.1-3.435.979-8.525,1.153-8.742l.029-.031c.633-.7,1.389-1.478,2.188-2.217A28.787,28.787,0,0,1,16.314.16.853.853,0,0,1,17.6.525,29.928,29.928,0,0,1,19.618,9.84a5.39,5.39,0,0,1-3.307,5.384,5.552,5.552,0,0,1-2.094.411M12.328,5.992c-.214.271-3.252,4.222-1.2,6.5a4.035,4.035,0,0,0,4.536,1.147,3.665,3.665,0,0,0,2.24-3.732A28.376,28.376,0,0,0,16.4,2.217,25.435,25.435,0,0,0,14.391,3.9c-.753.7-1.466,1.427-2.063,2.088"
          transform="translate(16.122 -0.001)"
          fill="#609690"
        />
      </g>
    </g>
  </SvgIcon>
);

export const MaterialPropertiesIcon: React.FC = () => (
  <svg width="31.2" height="34.11" viewBox="0 0 31.2 34.11">
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectangle_1418"
          data-name="Rectangle 1418"
          width="31.2"
          height="34.11"
          fill="#609690"
        />
      </clipPath>
    </defs>
    <g
      id="Material_properties_icon"
      data-name="Material properties icon"
      transform="translate(0 0)"
    >
      <g
        id="Group_1923"
        data-name="Group 1923"
        transform="translate(0 0)"
        clip-path="url(#clip-path)"
      >
        <path
          id="Path_2778"
          data-name="Path 2778"
          d="M13.107,14.043A10.546,10.546,0,0,1,3.183,6.975H.97a12.6,12.6,0,0,0,24.275,0H23.032a10.546,10.546,0,0,1-9.924,7.068"
          transform="translate(2.493 17.925)"
          fill="#609690"
        />
        <path
          id="Path_2779"
          data-name="Path 2779"
          d="M13.082,2.767c2.892,3.641,8.032,10.745,9.817,15.707h2.249C22.9,11.334,14.331.875,13.9.375a1.087,1.087,0,0,0-1.642,0C12.082.589,9.9,3.266,7.441,6.765S2.265,14.618,1.087,18.153l-.107.321H3.265C5.192,13.048,10.94,5.48,13.082,2.767"
          transform="translate(2.518 0)"
          fill="#609690"
        />
        <path
          id="Path_2780"
          data-name="Path 2780"
          d="M12.744,7.917V5.775H1.071A1.074,1.074,0,0,0,0,6.846,1.052,1.052,0,0,0,1.071,7.917H12.744Z"
          transform="translate(0 14.841)"
          fill="#609690"
        />
        <path
          id="Path_2781"
          data-name="Path 2781"
          d="M16.843,5.775H5.17V7.917H16.843a1.052,1.052,0,0,0,1.071-1.071,1.074,1.074,0,0,0-1.071-1.071"
          transform="translate(13.286 14.841)"
          fill="#609690"
        />
        <path
          id="Path_2782"
          data-name="Path 2782"
          d="M4.837,2.747V18.426H3.77l2.138,3.7,2.135-3.7H6.979V2.747Z"
          transform="translate(9.688 7.059)"
          fill="#609690"
        />
      </g>
    </g>
  </svg>
);

export const MethodIcon: React.FC = () => (
  <svg
    id="Method_Icon"
    data-name="Method Icon"
    width="34.354"
    height="30.759"
    viewBox="0 0 34.354 30.759"
  >
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectangle_1416"
          data-name="Rectangle 1416"
          width="34.354"
          height="30.759"
          fill="#609690"
        />
      </clipPath>
    </defs>
    <g
      id="Group_1920"
      data-name="Group 1920"
      transform="translate(0 0)"
      clip-path="url(#clip-path)"
    >
      <path
        id="Path_2767"
        data-name="Path 2767"
        d="M19.167,15.212a.977.977,0,0,0,.977-.977V1.721a.977.977,0,0,0-.977-.977H8.588V2.7h9.6V13.259H12.8V11.8L8.866,14.069l-.286.156.26.156L12.8,16.673V15.212Z"
        transform="translate(13.767 1.194)"
        fill="#609690"
      />
      <path
        id="Path_2768"
        data-name="Path 2768"
        d="M11.455,3.585V5.054l4.217-2.435L11.455.184V1.632H2.99a4.119,4.119,0,0,1,.1.99,3.906,3.906,0,0,1-.1.964Z"
        transform="translate(4.797 0.295)"
        fill="#609690"
      />
      <path
        id="Path_2769"
        data-name="Path 2769"
        d="M21.438,18.052H2.073V7.5h10.5a4.794,4.794,0,0,1-.13-1.068,4.871,4.871,0,0,1,.078-.886H1.11a.984.984,0,0,0-.99.964V19.041a.967.967,0,0,0,.99.964H21.438v1.469l4.217-2.435L21.438,16.6Z"
        transform="translate(0.193 8.905)"
        fill="#609690"
      />
      <path
        id="Path_2770"
        data-name="Path 2770"
        d="M2.891,5.834A2.848,2.848,0,0,0,5.626,3.881a2.439,2.439,0,0,0,.182-.964,2.567,2.567,0,0,0-.182-.99A2.9,2.9,0,0,0,0,2.917,2.907,2.907,0,0,0,2.891,5.834"
        transform="translate(0 0)"
        fill="#609690"
      />
      <path
        id="Path_2771"
        data-name="Path 2771"
        d="M13.867,9.57a2.917,2.917,0,1,0,2.917,2.917A2.912,2.912,0,0,0,13.867,9.57"
        transform="translate(17.569 15.355)"
        fill="#609690"
      />
      <path
        id="Path_2772"
        data-name="Path 2772"
        d="M8.567,4.77A2.917,2.917,0,0,0,5.806,6.8a2.536,2.536,0,0,0-.156.886,2.888,2.888,0,0,0,.208,1.068A2.987,2.987,0,0,0,8.567,10.6a2.917,2.917,0,0,0,0-5.834"
        transform="translate(9.065 7.654)"
        fill="#609690"
      />
    </g>
  </svg>
);

export const GalleryIcon: React.FC = () => (
  <svg width="35.551" height="30.03" viewBox="0 0 35.551 30.03">
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectangle_1415"
          data-name="Rectangle 1415"
          width="35.551"
          height="30.03"
          fill="#609690"
        />
      </clipPath>
    </defs>
    <g id="Gallery_icon" data-name="Gallery icon" transform="translate(0 0)">
      <g
        id="Group_1915"
        data-name="Group 1915"
        transform="translate(0 0)"
        clip-path="url(#clip-path)"
      >
        <path
          id="Path_2758"
          data-name="Path 2758"
          d="M25.512,26.507a.825.825,0,0,1-.826-.826V12.3a2.647,2.647,0,0,0-2.646-2.644H2.738a.829.829,0,0,1-.8-1.022L3.229,3.29A4.229,4.229,0,0,1,5.159.63,4.3,4.3,0,0,1,8.406.12L28.926,5.1a4.325,4.325,0,0,1,2.646,1.95,4.218,4.218,0,0,1,.5,3.241L28.9,23.37a4.253,4.253,0,0,1-3.211,3.117.809.809,0,0,1-.179.019M3.788,8H22.039a4.3,4.3,0,0,1,4.3,4.3V24.414a2.606,2.606,0,0,0,.964-1.443L30.463,9.9l0-.008a2.567,2.567,0,0,0-.306-1.977,2.664,2.664,0,0,0-1.63-1.2L8.023,1.726a2.7,2.7,0,0,0-2,.317A2.6,2.6,0,0,0,4.834,3.675Z"
          transform="translate(3.353 0)"
          fill="#609690"
        />
        <path
          id="Path_2759"
          data-name="Path 2759"
          d="M25.391,24.935H4.3a4.3,4.3,0,0,1-4.3-4.3V7.2a4.3,4.3,0,0,1,4.3-4.3H25.391a4.3,4.3,0,0,1,4.3,4.3V20.639a4.3,4.3,0,0,1-4.3,4.3M4.3,4.557A2.648,2.648,0,0,0,1.654,7.2V20.639A2.615,2.615,0,0,0,4.3,23.283H25.391a2.617,2.617,0,0,0,2.644-2.644V7.2a2.648,2.648,0,0,0-2.644-2.644Z"
          transform="translate(0.004 5.094)"
          fill="#609690"
        />
        <path
          id="Path_2760"
          data-name="Path 2760"
          d="M10.213,11.191a3.463,3.463,0,1,1,3.461-3.464,3.466,3.466,0,0,1-3.461,3.464m0-5.273a1.811,1.811,0,1,0,1.809,1.809,1.813,1.813,0,0,0-1.809-1.809"
          transform="translate(11.841 7.479)"
          fill="#609690"
        />
        <path
          id="Path_2761"
          data-name="Path 2761"
          d="M20.955,14.492a.811.811,0,0,1-.383-.094L8.979,8.329,1.087,10.95a.826.826,0,0,1-.52-1.567L8.792,6.652a.811.811,0,0,1,.644.052L20.969,12.74,28.3,9.188a.826.826,0,0,1,.719,1.487l-7.7,3.734a.832.832,0,0,1-.361.083"
          transform="translate(0.001 11.588)"
          fill="#609690"
        />
      </g>
    </g>
  </svg>
);

export const TimeIcon: React.FC = () => (
  <svg width="32.028" height="20.148" viewBox="0 0 32.028 20.148">
    <g id="Time_icon_" data-name="Time icon " transform="translate(0 0)">
      <g id="Group_1919" data-name="Group 1919" transform="translate(0 0)">
        <path
          id="Path_2762"
          data-name="Path 2762"
          d="M13.566,11.116a.682.682,0,0,1-.486-.2L9.473,7.308a.678.678,0,0,1-.2-.486V3.2a.688.688,0,0,1,1.376,0V6.537l3.4,3.4a.688.688,0,0,1-.486,1.174"
          transform="translate(11.987 3.249)"
          fill="#b7b5b5"
        />
        <path
          id="Path_2763"
          data-name="Path 2763"
          d="M18.163,20.148a10.048,10.048,0,0,1-7.475-3.318H3.619a.687.687,0,1,1,0-1.373H11a.683.683,0,0,1,.525.243,8.7,8.7,0,1,0,.018-11.267.685.685,0,0,1-.525.241h-7.4a.687.687,0,1,1,0-1.373h7.087a10.075,10.075,0,1,1,7.457,16.848"
          transform="translate(3.79 0)"
          fill="#b7b5b5"
        />
        <path
          id="Path_2764"
          data-name="Path 2764"
          d="M11.319,4.248H2.108a.688.688,0,1,1,0-1.376h9.211a.688.688,0,1,1,0,1.376"
          transform="translate(1.836 3.713)"
          fill="#b7b5b5"
        />
        <path
          id="Path_2765"
          data-name="Path 2765"
          d="M11.319,6.839H2.108a.688.688,0,0,1,0-1.376h9.211a.688.688,0,0,1,0,1.376"
          transform="translate(1.836 7.063)"
          fill="#b7b5b5"
        />
        <path
          id="Path_2766"
          data-name="Path 2766"
          d="M12.98,5.541H.688a.688.688,0,1,1,0-1.376H12.98a.688.688,0,1,1,0,1.376"
          transform="translate(0 5.385)"
          fill="#b7b5b5"
        />
      </g>
    </g>
  </svg>
);
